import React from 'react';
import {
  Segment,
  DropdownItem,
  DropdownMenu,
  Dropdown,
} from 'semantic-ui-react';
import { BulkQuestionTemplates, FiscalYears } from '../utils';

export const DropdownButton = ({ label, onClick }) => {
  return (
    <Segment
      basic
      clearing
      className="dropdown survey-question-action-dropdown"
    >
      <Dropdown text={label} button fluid className="ui green large button m-2">
        <DropdownMenu>
          {FiscalYears.map(year => (
            <Dropdown key={year} text={year} pointing="left" className="item">
              <DropdownMenu direction="left" className="dropdown-scroll-year">
                {BulkQuestionTemplates(year).map(x => (
                  <DropdownItem
                    key={x.value}
                    onClick={() => onClick(x, year)}
                    text={x.label}
                    className="dropdown-item"
                  />
                ))}
              </DropdownMenu>
            </Dropdown>
          ))}
        </DropdownMenu>
      </Dropdown>
    </Segment>
  );
};

export default DropdownButton;
